import ProductSpecificationGroupProvider from './hooks/useProductSpecificationGroup';

import { ProductSpecificationGroupProps } from './@types/ProductSpecificationGroupProps';

const ProductSpecificationGroup = (props: ProductSpecificationGroupProps) => (
	<ProductSpecificationGroupProvider {...props}>
		{/* <div> */}
		{props.children}
		{/* </div> */}
	</ProductSpecificationGroupProvider>
);

export default ProductSpecificationGroup;
